export const PROFILE_REQUEST = "PROFILE_REQUEST"
export const PROFILE_SUCCESS = "PROFILE_SUCCESS"
export const PROFILE_FAILURE = "PROFILE_FAILURE"


export const All_FRIENDS = "ALL_FRIENDS"

export const SINGLE_USER_PROFILE="SINGLE_USER_PROFILE"

export const SINGLE_USER_FRIENDS="SINGLE_USER_FRIENDS"

export const SINGLE_POST="SINGLE_POST"